const Button = ({ children, type = 'button', btnStyle = ButtonStyles.PRIMARY, ...props }) => {
    return (
        <button type={type} btn-type={btnStyle} {...props}>
            {children}
        </button>
    );
};

export const ButtonStyles = { PRIMARY: 'primary', SECONDARY: 'secondary' };
export default Button;
